<template>
    <div
        class="journey-layout"
        role="region"
        aria-label="Journey content layout"
    >
        <div class="journey-inner" :class="{ 'no-aside': !$slots.aside }">
            <main id="main-content" tabindex="-1">
                <slot name="main" />
            </main>
            <aside v-if="$slots.aside" aria-label="Additional information">
                <slot name="aside" />
            </aside>
        </div>
    </div>
</template>

<style scoped>
.journey-layout {
    display: flex;
    justify-content: center;
    width: 100%;
    background: var(--color-background);
    padding: 50px 0;
    flex: 1;

    &:nth-child(even) {
        background: var(--color-background-alt);
    }
}

.journey-inner {
    display: flex;
    align-items: flex-start;
    width: 100%;
}

main {
    flex: 0 0 75%;
    padding: 0 15px;
    outline: none;
}

.journey-inner.no-aside main {
    flex: 1 1 auto;
    width: 100%;
    padding-right: 0;
}

@media (width >= 993px) {
    .journey-inner {
        max-width: 960px;
    }
}

@media (width >= 1200px) {
    .journey-inner {
        max-width: 1140px;
    }

    main {
        flex: 0 0 855px;
    }

    aside {
        flex: 0 0 285px;
    }
}

@media (width <= 992px) {
    .journey-inner {
        flex-direction: column;
        width: 100%;
    }

    main,
    aside {
        width: 100%;
    }

    aside {
        border-top: 1px solid var(--color-border-light);
    }
}
</style>
